import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { domainsAPI } from '@hpanel/web-common/api/client'
import type { Domain } from '@hpanel/web-common/api/types'
import { useAuth } from '@hpanel/web-common/contexts/AuthContext'
import { CreateDatabaseForm } from '../../components/Databases/CreateDatabaseForm'

/** /client/databases/new — create a database as a routed page (CLAUDE.md §15). */
export const CreateDatabasePage: React.FC = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [domains, setDomains] = useState<Domain[] | null>(null)

  useEffect(() => {
    if (!user?.id) return
    domainsAPI
      .list(user.id)
      .then((res) => setDomains(res.domains))
      .catch((e) => {
        // The form still renders; the domain picker is just empty.
        // eslint-disable-next-line no-console
        console.error('[CreateDatabasePage] domains list failed', e)
        setDomains([])
      })
  }, [user?.id])

  return <CreateDatabaseForm domains={domains} onClose={() => navigate('/client/databases')} />
}
